import React from 'react';

const EmployeeRights: React.FC = () => {
  return (
    <div className="employee-rights">
      <h1>Mitarbeiter-Rechte</h1>
      <p>Verwaltung der Benutzerrollen und Berechtigungen.</p>
    </div>
  );
};

export default EmployeeRights;
